import React from 'react';
import './FullscreenStripeLoader.less';
import { CircularLoader } from 'app/components/loaders';
import { useTranslation } from 'react-i18next';

export default function FullscreenStripeLoader() {
  const { t } = useTranslation();

  return (
    <div className="fullscreen-stripe-loader">
      <CircularLoader />

      <p className="fullscreen-stripe-loader__title">
        {t('subscriptions.manage_your_plan.loaders.stripe.title')}
      </p>

      <p className="fullscreen-stripe-loader__subtitle">
        {t('subscriptions.manage_your_plan.loaders.stripe.subtitle')}
      </p>
    </div>
  );
}
